import { FC } from 'react'
import Link from 'next/link'
import styled from 'styled-components'
import Aside from 'src/components/Aside/Aside'
import { Image, Props } from 'src/containers/Home/components/Works'

const ListContainer = styled.section`
  display: flex;
  margin: 0 auto;
  margin-top: 48px;
  max-width: 1200px;

  figure {
    display: inline-block;
    margin-left: 24px;
    margin-bottom: 24px;
  }

  figcaption {
    margin-top: 8px;
    text-align: center;
    color: #000;
  }
`

const WorkList: FC<Props> = ({ works }) => {
  return (
    <ListContainer>
      <Aside />
      <div>
        {works.map((work) => {
          const { _id, name, imageUrl } = work
          return (
            <Link href={`work/${_id}`} key={_id}>
              <a>
                <figure>
                  <Image src={imageUrl} alt={name} />
                  <figcaption>{name}</figcaption>
                </figure>
              </a>
            </Link>
          )
        })}
      </div>
    </ListContainer>
  )
}

export default WorkList
